import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { GridDataResult, DataStateChangeEvent, RowClassArgs } from '@progress/kendo-angular-grid';
import { process, State } from '@progress/kendo-data-query';
import { OrderService } from '../../services/order.service';
import { QuoteOrderLinePlannedLoad, SearchQuoteOrderLine, SearchTagType } from '../../models/models';

@Component({
    selector: 'order-planned-grid',
    templateUrl: './order-planned-grid.component.html',
    standalone: false
})
export class OrderPlannedGrid implements OnInit, OnChanges {
    @Input() loads: QuoteOrderLinePlannedLoad[] = [];
    @Input() rfqQuotes: SearchQuoteOrderLine[] = [];
    @Input() loadStatus: string = '';
    @Input() isVisible: boolean = true;
    @Input() colSize: number = 2;
    @Input() gridSize: number = 12;
    @Output() onClick = new EventEmitter<any>();

    public tagTypeList: SearchTagType[] = [];

    public statusGridState: State = { sort: [{ dir: 'desc', field: 'nextEvent' }] };
    public gridState: State = { skip: 0, take: 150, sort: [{ dir: 'desc', field: 'nextEvent' }] };
    public rfqQuoteGridState: State = { skip: 0, take: 150, sort: [{ dir: 'desc', field: 'createdDate' }] };
    //public gridData: GridDataResult = process(this.loads, this.gridState);
    public statusGridData: GridDataResult = { data: [], total: 0 };
    public gridData: GridDataResult = { data: [], total: 0 };
    public rfqQuoteGridData: GridDataResult = { data: [], total: 0 };

    constructor(private orderService: OrderService, private router: Router) { }

    ngOnInit() {
        this.orderService.getSearchTagTypes().subscribe(result => {
            this.tagTypeList = result.resultCollection;
        });

        //this.gridData = process(this.loads, this.gridState);
    }

    ngOnChanges() {
        if (this.loadStatus == "Orders") {
            this.gridData = process(this.loads, this.gridState);
        }
        else if (this.loadStatus == "RFQ-Quote") {
            this.rfqQuoteGridData = process(this.rfqQuotes, this.rfqQuoteGridState);
        }
        else {
            this.statusGridData = process(this.loads, this.statusGridState);
        }
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        if (this.loadStatus == "Orders") {
            this.gridState = state;
            this.gridData = process(this.loads, this.gridState);
        }
        if (this.loadStatus == "RFQ-Quote") {
            this.rfqQuoteGridState = state;
            this.rfqQuoteGridData = process(this.rfqQuotes, this.rfqQuoteGridState);
        }
        else {
            this.statusGridState = state;
            this.statusGridData = process(this.loads, this.statusGridState);
        }
    }

    public loadClick(e: any) {
        var load = this.loads.find(q => q.quoteOrderLineID == e.dataItem.quoteOrderLineID);
        this.onClick.emit(load);
    }

    public getTagTypes(idList: string) {
        var tagTypes: SearchTagType[] = [];
        if (idList && idList != "") {
            var arr: number[] = [];
            arr = idList.replace(/, +/g, ",").split(",").map(Number);
            for (var i = 0; i < arr.length; i++) {
                var idx: number = this.tagTypeList.findIndex(t => t.tagTypeID == arr[i]);
                if (idx >= 0) {
                    tagTypes.push(this.tagTypeList[idx]);
                }
            }
        }
        return tagTypes;
    }

    public rowCallback(context: RowClassArgs) {
        const isHighPriority = (context.dataItem.loadPriorityAbbreviation == "High");
        const isExpedite = (context.dataItem.rateIndex == "Expedite");
        const isCG = (context.dataItem.erpAssignedTo == "CG" || context.dataItem.quoteOrderLineType == "CG");
        const isRFQP = (context.dataItem.quoteOrderLineType == "RFQP");
        if (isExpedite) {
            return {
                expedite: isExpedite
            }
        }
        else if (isHighPriority) {
            return {
                highPriority: isHighPriority
            }
        }
        else if (isCG) {
            return {
                warning: isCG
            }
        }
        else if (isRFQP) {
            return {
                warning: isRFQP
            }
        }
    }
}
